import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/HelloWorld'
import ShowTest from '@/components/ShowTest'
import Devices from '@/components/Devices'
import DeviceAdd from '@/components/DeviceAdd'

import Login from '@/components/Login'
import DashBoard from '@/components/DashBoard'
import ShowTests from '@/components/ShowTests'
import Stats from '@/components/Stats'
import ActivationComponent from '@/components/Pairing'
import AdminSearchComponent from '@/components/admin/Search'
import ShowCurves from '@/components/admin/ShowCurves'
import ScreeningPortal from '@/components/ScreeningPortal'
import Documents from '@/components/Documents'
import SettingsComponent from '@/components/Settings'
import fqd from '@/components/FQD.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        redirect:'/dashboard'
      },
      {
        path: '/login',
        name: 'login',
        component: Login,
        props: true,
      }, 
      
      {
        path: '/login/:custid',
        name: 'autologin',
        component: Login,
        props: true,
      }, 
      
      

      {
        path: '/code',
        name: 'Pairing',
        component: ActivationComponent,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'pcr',
        } 
      },  

      {
        path: '/screening-portal',
        name: 'ScreeningPortal',
        component: ScreeningPortal,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'dfu',
        } 
      }, 


      {
        path: '/curves/:testid',
        name: 'ShowCurves',
        component: ShowCurves,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'pcr',
        } 
      },      


      {
        path: '/admin/search',
        name: 'AdminSearch',
        component: AdminSearchComponent,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'pcr',
        } 
      },  

      {
        path: '/code/:id',
        name: 'PairingCode',
        component: ActivationComponent,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'pcr',
        } 
      },        
      

      {
        path: '/logout',
        name: 'logout',
        component: Hello,
        props: true,
      },  
      
      {
        path: '/test/:id',
        name: 'ShowThisTest',
        component: ShowTest,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'tests',
        }           
      }, 

      {
        path: '/tests',
        name: 'ShowTests',
        component: ShowTests,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'tests',
        }           
      },   

      {
        path: '/tests/:device',
        name: 'ShowTestsForDevice',
        component: ShowTests,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'tests',
        }           
      },   
      

      {
        path: '/devices',
        name: 'devices',
        component: Devices,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'pcr',
        }        
      },

      {
        path: '/devices/add',
        name: 'addcycler',
        component: DeviceAdd,
        props: true,
        meta: {
          requiresAuth: true,
        }        
      },


      {
        path: '/statistics',
        name: 'stats',
        component: Stats,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'stat',
        }        
      },            
      {
        path: '/dashboard',
        name: 'dashboard',
        component: DashBoard,
        props: true,
        meta: {
            requiresAuth: true,
        }
      },            
      {
        path: '/documents',
        name: 'documents',
        component: Documents,
        props: true,
        meta: {
            requiresAuth: true,
        }
      },
      {
        path: '/fqd',
        name: 'fqd',
        component: fqd,
        props: true,
        meta: {
            requiresAuth: true,
            grouo: 'tests',
        }
      },
      {
        path: '/settings',
        name: 'Settings',
        component: SettingsComponent,
        props: true,
        meta: {
          requiresAuth: true,
          group: 'cfg',
        } 
      },
      {
        path :'*',
        redirect: 'Login'
    }
  ]
})
